<div
  class="rounded-lg border border-brand-primary-lighter bg-brand-primary-lightest p-3"
>
  <div class="mb-2 flex items-center justify-between">
    <h3 class="text-sm font-bold text-brand-primary-pure">{{ title() }}:</h3>

    @if (deadline()) {
      <span class="text-xs font-medium text-neutral-low-medium"
        >Data final: {{ deadline() | date: 'shortDate' : 'pt_BR' }}</span
      >
    }
  </div>
  @if (!hasBeenSentToPrinting() && issues().length === 0) {
    <div class="flex flex-col text-sm font-normal text-neutral-low-dark">
      <p>Tudo pronto por aqui!</p>
      <p>Não existem pendências nesta turma.</p>
      <p>Você já pode enviar os livros para a produção. 🚀</p>
    </div>
  } @else {
    <ul class="flex flex-col gap-0.5 text-neutral-low-dark">
      @for (issue of issues(); track issue.title) {
        <li class="flex flex-col">
          <span class="text-sm font-bold">{{ issue.title }}</span>

          <p class="text-sm/4">‣ {{ issue.description }}</p>
        </li>
      }
    </ul>
  }
</div>
